import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import ContentLoader from "react-content-loader";
import { Link } from "react-router-dom";

const ContentCard = ({
  card,
  onUpdate,
  onRemove,
  canRemove,
  onClick,
  videoSessionId,
  props,
  getList,
  getCardData,
  setRefreshLoader,
  refreshLoader,
  isSelected,
  onSelectChange,
}) => {
  const [imagePreviewModal, setImagePreviewModal] = useState(null);
  const [videoPreviewModal, setVideoPreviewModal] = useState(null);
  const [showimagePreview, setShowimagePreview] = useState(false);
  const [showVideoPreview, setShowVideoPreview] = useState(false);
  const [loadingReload, setLoadingReload] = useState(false);
  const [loadingGen, setLoadingGen] = useState(false);
  const [stepError, setStepError] = useState("");
  const [headingError, setHeadingError] = useState("");
  const [isStepHeadingDisabled, setIsStepHeadingDisabled] = useState(true);


  const splitPromptIntoChunks = (prompt) => {
    const words = prompt.split(" ");
    const chunks = [];
    for (let i = 0; i < words.length; i += 100) {
      chunks.push(words.slice(i, i + 100).join(" "));
    }
    return chunks;
  };
  const handleGenerateImageAndScript = async (id) => {
    try {
      const payload = {
        user_text: card.prompt,
        start: card.startPrompt,
        end: card.endPrompt,
        title: "",
        end_status: card.isChecked,
      };
      const response = await props.admin.generateImageScript(
        videoSessionId,
        payload
      );

      if (response.success && response.data?.video_input_id) {
        const videoInputId = response.data.video_input_id.toString();

        // ✅ CALL getCardData passed from parent
        localStorage.setItem("cardId", id);
        await getCardData(videoInputId); 
      } else {
        throw new Error("API failed.");
      }
    } catch (error) {
      console.error("Generation failed:", error);
      toast.dismiss();
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const handlecloseModel = () => {
    setShowimagePreview(false);
  };
  const handleVideoCloseModel = () => {
    setShowVideoPreview(false);
  };
  const handleImagePreview = (itemId) => {
    const item = card.generatedItems.find((i) => i.id === itemId);
    if (item) {
      setImagePreviewModal(item.image);
      setShowimagePreview(true);
      toast({
        title: "Image Preview",
        description: "Opening image preview...",
      });
    }
  };
  const handleImageUpload = (itemId, cardId) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/png"; // only PNG files

    input.onchange = async (e) => {
      const file = e.target.files?.[0];
      console.log("cards", cardId);

      if (file) {
        // ✅ Validate file type
        if (file.type !== "image/png") {
          toast.error("Only PNG files are allowed.", {
            position: toast.POSITION.TOP_CENTER,
          });
          return;
        }

        const formData = new FormData();
        formData.append("uploaded_image", file);

        try {
          const response = await props.admin.uploadImageReplacement(
            videoSessionId,
            itemId,
            cardId,
            formData
          );

          if (response.success && response.data?.image_url) {
            getList();
            const updatedItems = card.generatedItems.map((item) =>
              item.id === itemId
                ? { ...item, image: response.data.image_url }
                : item
            );

            onUpdate({ generatedItems: updatedItems });

            toast.success("Image uploaded successfully!", {
              position: toast.POSITION.TOP_CENTER,
            });
          } else {
            throw new Error("Upload failed");
          }
        } catch (error) {
          console.error("Upload failed:", error);
          toast.error("Failed to upload image. Please try again.", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
    };

    input.click();
  };
  const handleImageDownload = (itemId) => {
    const item = card.generatedItems.find((i) => i.id === itemId);
    if (item && item.imageDownload) {
      const link = document.createElement("a");
      link.href = item.imageDownload;
      link.download = `generated-image-${itemId}.png`; // You can change extension or filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.dismiss();
      toast({
        title: "Downloading Image",
        description: "Your image will download shortly...",
      });
    } else {
      toast.dismiss();
      toast({
        title: "Download Failed",
        description: "Image not found.",
        status: "error",
      });
    }
  };

  const handleVideoPreview = (itemId) => {
    const item = card.generatedItems.find((i) => i.id === itemId);
    if (item && item.video) {
      setVideoPreviewModal(item.video);
      setShowVideoPreview(true);
      toast({
        title: "Video Preview",
        description: "Opening video preview...",
      });
    }
  };

  const handleDeleteItem = async (itemId, cardId) => {
    try { 
      const response = await props.admin.deleteImageScript(itemId); // Call your API

      if (response.success) {
        const updatedItems = card.generatedItems.filter(
          (item) => item.id !== itemId
        );
        onUpdate({ generatedItems: updatedItems });
        toast.dismiss();
        toast.success("Item deleted successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        throw new Error("Delete API failed");
      }
    } catch (error) {
      toast.dismiss();
      console.error("Failed to delete item:", error);
      toast.error("Failed to delete item. Please try again.", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const updateItemScriptLocally = (itemId, newScript) => {
    const updatedItems = card.generatedItems.map((item) =>
      item.id === itemId ? { ...item, script: newScript } : item
    );
    onUpdate({ generatedItems: updatedItems });
  };

  const updateItemScriptAPI = async (itemId, newScript) => {
    try {
      const data = { video_script: newScript };
      const response = await props.admin.updateScript(itemId, data);

      if (response.success) {
        toast.dismiss();
        toast.success("Script updated successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        throw new Error("Update failed");
      }
    } catch (error) {
      toast.dismiss();
      console.error("Script update error:", error);
      toast.error("Failed to update script. Please try again.", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const handleGenerateVideo = async (cardId) => {
    try {
      setLoadingGen(true);
      const response = await props.admin.createVideoInput(cardId);

      if (response.success) {
        toast.dismiss();
        toast.success("Video is being processed... please wait.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });

        // Wait 5 seconds before fetching updated data
        setTimeout(async () => {
          await getCardData(cardId);
          setLoadingGen(false); // ✅ move inside setTimeout to ensure it's set after data is fetched
        }, 5000);
      } else {
        throw new Error("Video generation failed.");
      }
    } catch (error) {
      toast.dismiss();
      console.error("Video generation error:", error);
      toast.error("❌ Failed to generate video. Please try again.", {
        position: toast.POSITION.TOP_CENTER,
      });
      setLoadingGen(false); // ✅ ensure this runs on error
    }
  };

  // const handleCreateStepAndHeading = async (prompt) => {
  //   try {
  //     // setLoadingGen(true);
  //     
  //     const response = await props.admin.createStepAndHeading(prompt);

  //     if (response.success) {
  //       toast.dismiss();
  //       toast.success("Video is being processed... please wait.", {
  //         position: toast.POSITION.TOP_CENTER,
  //         autoClose: 3000,
  //       });

  //       // Wait 5 seconds before fetching updated data
  //       setTimeout(async () => {
  //         // await getCardData(cardId);
  //         setLoadingGen(false); // ✅ move inside setTimeout to ensure it's set after data is fetched
  //       }, 5000);
  //     } else {
  //       throw new Error("Video generation failed.");
  //     }
  //   } catch (error) {
  //     toast.dismiss();
  //     console.error("Video generation error:", error);
  //     toast.error("❌ Failed to generate video. Please try again.", {
  //       position: toast.POSITION.TOP_CENTER,
  //     });
  //     // setLoadingGen(false); // ✅ ensure this runs on error
  //   }
  // };

  const handleCreateStepAndHeading = async (prompt) => {
  
    
    try {

    

  
      const response = await props.admin.createStepAndHeading(prompt) // your API function
      
      if (response?.success) {
        onUpdate({ startPrompt: response?.data?.step_number || "",
          endPrompt:response?.data?.heading || ""
        });
        setIsStepHeadingDisabled(false);
        // toast.success(response.message || "Step & Heading generated!");
      } else {
        toast.error(response.message ||"Failed to fetch step & heading");
      }
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };
  
  // const decodeHTML = (str) => {
  //   const txt = document.createElement("textarea");
  //   txt.innerHTML = str;
  //   return txt.value;
  // };
  // console.log(card.prompt);

  return (
    <>
      <div className="tab-content  create-videomodel" id="myTabContent">
        <div className="row">
          <div className="addmore" style={{ justifyContent: "end" }}>
            <div className="d-flex">
              <button onClick={onClick}>+</button>
              {canRemove && <button onClick={onRemove}>-</button>}
            </div>
          </div>
          <div className="col-4">
            <div className="">
              <label htmlFor="" className="form-label">
                Add prompt here
              </label>
            </div>
            <div className="sopvideoform">
              <div className="mb-1 ">
                <div className="step-heading">
                <label htmlFor="" className="form-label">
                 
                </label>
               <div className="step-btn">
                    <button
                     className="btn btn-primary mt-0"
                      type="button"
                      // role="switch"
                      // id={`toggle-${card.id}`}
                      // value={card.isChecked}
                      onClick={()=>handleCreateStepAndHeading(card.prompt)}
                      disabled={card.prompt === ""}
                        
                      
                    >
                     Generate StepNo / Heading
                    </button>
                  </div>
                  </div>
                <textarea
                  type="text"
                  className="form-control"
                  value={card.prompt}
                  // value={decodeHTML(card.prompt)}

                  onChange={(e) => onUpdate({ prompt: e.target.value })}
                  placeholder="Enter and copy paragraph here ..."
                  rows={4}
                  readOnly={card.status}
                />
                <div className="checkboxEndpart">
                  <p className="itemcount mt-1">
                    {card.prompt.split(" ").length} words
                  </p>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id={`toggle-${card.id}`}
                      checked={card.isChecked}
                      onChange={(e) =>
                        onUpdate({ isChecked: e.target.checked })
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`toggle-${card.id}`}
                    >
                      End part
                    </label>
                  </div>
                </div>
              </div>
              
              <div className="mb-1">
                <label htmlFor="" className="form-label">
                  Step Number
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter step number..."
                  value={card.startPrompt}
                  maxLength={101}
                  disabled={isStepHeadingDisabled}  
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length > 100) {
                      setStepError("Step number must be under 100 characters");
                    } else if (value === "") {
                      setStepError("Step number is required");
                    } else {
                      setStepError("");
                    }
                    onUpdate({ startPrompt: value });
                  }}
                  readOnly={card.status}
                 
                />
                {stepError && <div className="text-danger">{stepError}</div>}
              </div>
              <div className="mb-2">
                <label htmlFor="" className="form-label">
                  Heading
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter heading..."
                  value={card.endPrompt}
                  maxLength={200}
                  disabled={isStepHeadingDisabled}  
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length > 200) {
                      setHeadingError("Heading must be under 200 characters");
                    } else if (value === " ") {
                      setHeadingError("Heading is required");
                    } else {
                      setHeadingError("");
                    }
                    onUpdate({ endPrompt: value });
                  }}
                  readOnly={card.status}
                />
                {headingError && (
                  <div className="text-danger">{headingError}</div>
                )}
              </div>

              {card.status === "" && (
                <button
                  className="btn btn-primary mt-2"
                  onClick={() => handleGenerateImageAndScript(card.id)}
                  disabled={
                    !card.prompt ||
                    !card.startPrompt ||
                    !card.endPrompt ||
                    stepError !== "" ||
                    headingError !== ""
                  }
                >
                  {" "}
                  Generate Images and Scripts
                </button>
              )}
              {card.status === false && (
                <>
                  <button
                    className="btn btn-primary mt-2 "
                    onClick={async () => {
                      setLoadingReload(true);
                      await getCardData(card.id);
                      setTimeout(async () => {
                        setLoadingReload(false);
                      }, 2000);
                    }}
                    disabled={loadingReload}
                  >
                    {" "}
                    {loadingReload ? (
                      <>
                        <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                        Reloading
                      </>
                    ) : (
                      <>
                        <i className="fa-solid fa-rotate-right"></i> Reload
                      </>
                    )}
                  </button>
                </>
              )}
            </div>
          </div>
          <div className="col-4">
            <div className="mb-1 ">
              <label htmlFor="" className="form-label">
                Generated Images and Scripts
              </label>
              {card.generatedItems.length === 0 && card.status === "" ? (
                // createimge
                <div className="createVideo">
                  <div className="logo1 m-0">🖼️</div>
                  <p>Generated images will appear here</p>
                </div>
              ) : card.generatedItems.length === 0 && card.status === false ? (
                //createimgecontentLoader
                <div className="createVideo">
                  <ContentLoader
                    speed={2}
                    viewBox="0 0 500 500" // width 500, height 250 — change ratio if needed
                    backgroundColor="#f3e7e7"
                    foregroundColor="#c7cdea"
                    width="100%" // ✅ responsive width
                    height="auto" // ✅ let height scale with width (based on viewBox)
                    style={{ maxWidth: 450, height: 250 }} // ✅ CSS fallback
                  >
                    <path d="M484.52,64.61H15.65C7.1,64.61.17,71.2.17,79.31V299.82c0,8.12,6.93,14.7,15.48,14.7H484.52c8.55,0,15.48-6.58,15.48-14.7V79.31C500,71.2,493.07,64.61,484.52,64.61Zm-9,204.34c0,11.84-7.14,21.44-15.94,21.44H436.39L359.16,171.52c-7.1-10.92-19.67-11.16-27-.51L258.64,277.94C253.78,285,245.73,286,240,280.2l-79.75-80.62c-6-6.06-14.33-5.7-20,.88L62.34,290.39H40.63c-8.8,0-15.94-9.6-15.94-21.44V110.19c0-11.84,7.14-21.44,15.94-21.44H459.54c8.8,0,15.94,9.6,15.94,21.44Z" />
                    <ellipse cx="100" cy="120" rx="18" ry="18" />
                    <rect x="0" y="390" rx="5" ry="5" width="500" height="10" />
                    <rect x="0" y="410" rx="4" ry="4" width="400" height="10" />
                    <rect x="0" y="430" rx="4" ry="4" width="250" height="10" />
                    <rect x="0" y="450" rx="4" ry="4" width="400" height="10" />
                    <rect x="0" y="470" rx="4" ry="4" width="500" height="10" />
                  </ContentLoader>
                </div>
              ) : (
                <div className="scrollable-container">
                  {card.generatedItems.map((item, index) => (
                    <div key={item.id} className="createimgescript">
                      <div className="generateheader">
                        <p style={{ fontSize: "15px" }}>Item {index + 1}</p>
                        <div className="custom-action-buttons">
                          <button
                            size="sm"
                            variant="secondary"
                            className="btn btn-primary btn-sm"
                            onClick={() => handleImagePreview(item.id)}
                            title="Preview Image"
                          >
                            <i className="fa-solid fa-eye"></i>
                          </button>
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => handleImageDownload(item.id)}
                            title="Download image"
                          >
                            <i className="fa-solid fa-download"></i>
                          </button>
                          <button
                            size="sm"
                            variant="secondary"
                            className={`${
                              card.generatedItems[0].video ||
                              card.video_status === false
                                ? "btn btn-secondary btn-sm "
                                : "btn btn-danger btn-sm"
                            }`}
                            onClick={() => handleDeleteItem(item.id, card.id)}
                            title="Delete Item"
                            disabled={
                              card.generatedItems[0].video ||
                              card.video_status === false
                            }
                            style={{
                              cursor: `${
                                card.generatedItems[0].video ||
                                card.video_status === false
                                  ? "no-drop"
                                  : "pointer"
                              }`,
                            }}
                          >
                            <i class="fa-solid fa-trash"></i>
                          </button>
                          <button
                            size="sm"
                            variant="secondary"
                            className="btn btn-primary btn-sm"
                            onClick={() => handleImageUpload(item.id, card.id)}
                            title="Upload New Image"
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            <i class="fa-solid fa-upload"></i>
                          </button>
                        </div>
                      </div>

                      {/* Image with action icons */}
                      <div className="generatedicon">
                        <img
                          src={item.image}
                          alt={`Generated image ${index + 1}`}
                          className="generatedimage "
                          onClick={() => handleImagePreview(item.id)}
                        />
                      </div>

                      {/* Script textarea */}
                      <div className="position-relative">
                        <textarea
                          value={item.script}
                          type="text"
                          className="form-control mt-3"
                          onChange={
                            (e) =>
                              updateItemScriptLocally(item.id, e.target.value) // Only updates local state
                          }
                          rows={4}
                          style={{ background: "#fff" }}
                        />
                        <div className="editscript">
                          <button
                            className="btn btn-primary btn-sm position-absolute"
                            style={{
                              top: 8,
                              right: 8,
                              cursor: "pointer",
                            }}
                            title="Save Script"
                            onClick={() =>
                              updateItemScriptAPI(item.id, item.script)
                            }
                          >
                            <i className="fa-solid fa-pen"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="col-4">
            <div className="mb-1 ">
              <label className="form-label">Generated Videos</label>

              {card.generatedItems.length === 0 ? (
                //createimges
                <div className=" createVideo">
                  <div className="logo2 m-0">📹</div>
                  <p>Generated videos will appear here</p>
                </div>
              ) : (
                <div className="scrollable-container">
                  <div className="createVideo" style={{ minHeight: 0 }}>
                    <div className="generateheader">
                      <p style={{ fontSize: "15px" }}>Video</p>
                      {card.generatedItems[0].video && (
                        <div className="custom-action-buttons">
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() =>
                              handleVideoPreview(card.generatedItems[0].id)
                            }
                            title="Preview Video"
                          >
                            <i className="fa-solid fa-eye"></i>
                          </button>
                          <Link
                            to={card.generatedItems[0].videoDownload}
                            download
                          >
                            <button
                              className="btn btn-primary btn-sm"
                              title="Download Video"
                            >
                              <i className="fa-solid fa-download"></i>
                            </button>
                          </Link>
                        </div>
                      )}
                    </div>
                    {card.generatedItems[0]
                      ?.video ? null : card.video_status === false ? (
                      <button
                        className={`${
                          loadingReload
                            ? "btn btn-secondary  custom-generate-button mt-2"
                            : "btn btn-primary custom-generate-button mt-2 "
                        }`}
                        onClick={async () => {
                          setLoadingReload(true);
                          await getCardData(card.id);
                          setTimeout(async () => {
                            setLoadingReload(false);
                          }, 2000);
                        }}
                        disabled={loadingReload}
                      >
                        {loadingReload ? (
                          <>
                            <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                            Reloading
                          </>
                        ) : (
                          <>
                            <i className="fa-solid fa-rotate-right"></i> Reload
                          </>
                        )}
                      </button>
                    ) : (
                      <button
                        onClick={() => handleGenerateVideo(card.id)}
                        className={`${
                          loadingGen
                            ? "btn btn-secondary  custom-generate-button"
                            : "custom-generate-button"
                        }`}
                        data-generate="video"
                        disabled={loadingGen}
                      >
                        {loadingGen ? (
                          <>
                            <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                          </>
                        ) : (
                          "Generate Video"
                        )}
                      </button>
                    )}

                    {card.video_status === true && (
                      <button
                        onClick={() => handleGenerateVideo(card.id)}
                        className={`${
                          loadingGen
                            ? "btn btn-secondary  custom-generate-button"
                            : "custom-generate-button"
                        }`}
                        data-generate="video"
                        disabled={loadingGen}
                      >
                        {loadingGen ? (
                          <>
                            <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                          </>
                        ) : (
                          "Regenerate Video"
                        )}
                      </button>
                    )}

                    <div className="relative">
                      {card.generatedItems[0].video ? (
                        <video
                          src={card.generatedItems[0].video}
                          style={{ width: "100%", height: "205px" }}
                          controls
                        />
                      ) : card.video_status === false ? (
                        <ContentLoader
                          speed={3}
                          viewBox="0 0 500 500"
                          height="auto"
                          width="100%"
                          backgroundColor="#f3e7e7"
                          foregroundColor="#c7cdea"
                          style={{ width: 200, height: 200 }}
                        >
                          <path d="M484.52,64.61H15.65C7.1,64.61.17,71.2.17,79.31V299.82c0,8.12,6.93,14.7,15.48,14.7H484.52c8.55,0,15.48-6.58,15.48-14.7V79.31C500,71.2,493.07,64.61,484.52,64.61Zm-9,204.34c0,11.84-7.14,21.44-15.94,21.44H436.39L359.16,171.52c-7.1-10.92-19.67-11.16-27-.51L258.64,277.94C253.78,285,245.73,286,240,280.2l-79.75-80.62c-6-6.06-14.33-5.7-20,.88L62.34,290.39H40.63c-8.8,0-15.94-9.6-15.94-21.44V110.19c0-11.84,7.14-21.44,15.94-21.44H459.54c8.8,0,15.94,9.6,15.94,21.44Z" />
                          <ellipse cx="120" cy="140" rx="28" ry="28" />
                          <rect
                            x="0"
                            y="350"
                            rx="5"
                            ry="5"
                            width="500"
                            height="10"
                          />
                          <rect
                            x="0"
                            y="370"
                            rx="4"
                            ry="4"
                            width="400"
                            height="10"
                          />
                        </ContentLoader>
                      ) : (
                        <div className="custom-video-box">
                          <div className="text-center text-gray-400">
                            <div className="logo2 mb-1">📹</div>
                            <p style={{ color: "gray" }}>
                              Generated videos will appear here
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Image Preview Modal */}
      {imagePreviewModal && (
        <Modal
          show={showimagePreview}
          onHide={handlecloseModel}
          size="md"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Generate Image</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <img
              src={imagePreviewModal}
              alt="Preview"
              style={{ width: "100%" }}
            />
          </Modal.Body>
        </Modal>
      )}

      {/* Video Preview Modal */}
      {videoPreviewModal && (
        <Modal
          show={showVideoPreview}
          onHide={handleVideoCloseModel}
          size="md"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Video</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <video
              src={videoPreviewModal}
              style={{ width: "100%" }}
              controls
              preload="auto"
            />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default ContentCard;
